import { CommonModule } from '@angular/common';
import { Component, OnDestroy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterModule, RouterOutlet } from '@angular/router';
import { MainService } from '@api/custom-services/main.service';

interface TabLink {
   name: string;
   icon?: string;
   link?: string;
}

@Component({
   selector: 'app-promoter',
   imports: [
      CommonModule,
      RouterOutlet,
      MatCardModule,
      MatButtonModule,
      MatIconModule,
      MatToolbarModule,
      RouterModule,
      MatTabsModule,
   ],
   templateUrl: './promoter.component.html',
   styleUrl: './promoter.component.scss',
})
export class PromoterComponent implements OnDestroy {
   public topbarTemplate$ = this.mainService.topbarTemplate$;

   tabs: TabLink[] = [
      {
         name: 'Home',
         icon: 'home',
         link: '/promoter/ticket',
      },
      {
         name: 'History',
         icon: 'history',
         link: '/promoter/history',
      },
      {
         name: 'Events',
         icon: 'events',
         link: '/promoter/events-info',
      },
      {
         name: 'Profile',
         icon: 'account_circle',
         link: '/promoter/profile',
      },
   ];

   constructor(private mainService: MainService) {
      document.body.classList.add('app-promoter');
   }

   ngOnDestroy() {
      document.body.classList.remove('app-promoter');
   }
}
